export default __webpack_public_path__ + "static/media/1.239cc1e9.jpg";